import { Balance } from 'mbs-ui-shared@components/components/models/license.model';
import { LicenseType } from 'mbs-ui-shared@models';
import { LicenseAssignToAdmin, LicenseTypeSummary } from 'mbs-ui-shared@models/License';
import { PermissionFlags } from 'mbs-ui-shared@models/PermissionFlags';

export type LicensesState = {
  licenseTypes: Array<LicenseTypeSummary>;
  licenseTypesMap: Map<LicenseType, string>;
  licenseTypesLoading: boolean;

  permissionFlags: PermissionFlags;
  permissionFlagsLoaded: boolean;

  balance: Balance;

  actionsInLoading: number;

  assignedLicense: LicenseAssignToAdmin;
};

export const initialLicensesState: LicensesState = {
  licenseTypes: null,
  licenseTypesMap: null,
  licenseTypesLoading: false,

  permissionFlags: null,
  permissionFlagsLoaded: false,

  balance: null,

  actionsInLoading: 0,

  assignedLicense: null
};
